import React from 'react';
import { IStandardDocumentVersionData } from '../../../../../types/order/documents/shared/interfaces';
import { IconType, NavigationItem, RotatingIcon } from '../../../../../ui-toolkit';

export interface IDeleteLinkProps {
  isAmericanDigital: boolean;
  fetchingStatus: boolean;
  onDelete: (docId: string, versionId: string) => void;
  document: IStandardDocumentVersionData;
}

export const DeleteLink: React.FC<IDeleteLinkProps> = ({ isAmericanDigital, fetchingStatus, onDelete, document }) => {
  if (isAmericanDigital) return null;
  if (fetchingStatus) return <RotatingIcon type={IconType.Loading} />;
  return <NavigationItem text={'Delete'} onClick={() => onDelete(document.id, document.versionId)} isInline />;
};
